export default "__VITE_ASSET___qkzDTRT__"